import CodeMirror from 'codemirror/lib/codemirror'

const mixinCodeMirror = {
  data() {
    return {
      code: '',
      defaultEditorVal: `//定义函数
const test1 = function() {
  console.log(1)
}
//执行函数
test1()
/*变量：
  ** 1. that：可取that.viewFormData.modelData, that.$http 等需要的值
  ** 2. row：仅二维表可用，取当前行的所有值
  ** 3. item：按钮本身相关属性
  ** 4. window：DOM文档的窗口
  */
console.log(that, row)

//导出二维表数据: 例子
console.log(that.viewFormData.modelData['zibiao2'])
`
    }
  },
  mounted() {
    const that = this
    const editor = CodeMirror.fromTextArea(this.$refs.mycode, {
      mode: 'javascript',
      theme: 'theme',
      lineNumbers: true
    })
    editor.on('change', function() {
      that.code = editor.getValue()
    })
    editor.setValue(this.defaultEditorVal)

    this.editor = editor

    setTimeout(() => {
      const els = document.getElementsByClassName('editor')
      if (els.length && window.scale) {
        els[0].style.zoom = 1 / window.scale
      }
    }, 1500)
  },
  methods: {
    codeSetVal(row) {
      if (row.eventName) {
        this.editor.setValue(row.eventName)
      } else {
        this.editor.setValue(this.defaultEditorVal)
      }
    }
  }
}

export default mixinCodeMirror
